// Heart names for multi-heart necklaces (Generations Heart Necklace): one
// name field per heart, showing as many fields as the "Number of Hearts"
// option is set to (3, 4 or 5). Same layout and styling as the Minihearts
// block (anthology-extras.css), but the hearts are part of the chosen variant
// here, so nothing is added to the cart - each name is just a line item
// property on the main product: "Heart 1 Name", "Heart 2 Name", ...
//
// Rows beyond the chosen count are hidden AND disabled (a disabled field is
// not submitted), and what was typed is kept if the customer changes the
// count and comes back. Mount: <div data-anthology-heartnames data-step="4"
// data-option="Number of Hearts" data-max="5"> (see product-customizer.liquid,
// tag "Heart Names").
(function () {
  var MAX_LENGTH_DEFAULT = 20;
  var LABEL_DEFAULT = 'Heart';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  // The chosen option value, whichever way the variant picker renders it
  // (radio buttons or the custom dropdown).
  function selectedCount(optionName, fallback) {
    var fieldset = document.querySelector('variant-picker [data-option="' + optionName + '"]');
    if (!fieldset) return fallback;
    var value = null;
    var checked = fieldset.querySelector('input.js-option:checked');
    if (checked) {
      value = checked.value;
    } else {
      var selected = fieldset.querySelector('.custom-select__option[aria-selected="true"]');
      if (selected) value = selected.dataset.value;
    }
    var n = parseInt(value, 10);
    return n > 0 ? n : fallback;
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var optionName = root.dataset.option || 'Number of Hearts';
    var max = parseInt(root.dataset.max, 10) || 5;
    var unitLabel = root.dataset.label || LABEL_DEFAULT;
    var maxLength = parseInt(root.dataset.maxlength, 10) || MAX_LENGTH_DEFAULT;
    var unitLabelLower = unitLabel.toLowerCase();
    var rows = [];

    root.appendChild(el('div', 'label anthology-extra__label', (root.dataset.step || '') + '. ' + unitLabel + ' Names'));

    for (var i = 1; i <= max; i++) {
      var row = el('div', 'anthology-hn__row');
      var inputId = 'anthology-heart-name-' + i;
      var label = el('label', 'anthology-mh__pick-label', unitLabel + ' ' + i + ' name');
      label.setAttribute('for', inputId);
      var input = document.createElement('input');
      input.type = 'text';
      input.id = inputId;
      input.name = 'properties[' + unitLabel + ' ' + i + ' Name]';
      input.maxLength = maxLength;
      input.autocomplete = 'off';
      input.placeholder = 'Name for ' + unitLabelLower + ' ' + i;
      input.className = 'anthology-mh__select anthology-hn__input';
      row.appendChild(label);
      row.appendChild(input);
      root.appendChild(row);
      rows.push({ row: row, input: input });
    }

    root.appendChild(el('div', 'anthology-hn__hint', 'One name per ' + unitLabelLower + ', up to ' + maxLength + ' characters.'));

    function mainForm() {
      return document.querySelector('form.js-product-form-main');
    }
    // The block sits outside the main product <form> (Canopy only wraps the
    // buy buttons in it), so point the inputs at it with form="".
    function associate() {
      var form = mainForm();
      var id = form && form.getAttribute('id');
      if (!id) return;
      rows.forEach(function (r) {
        if (r.input.getAttribute('form') !== id) r.input.setAttribute('form', id);
      });
    }

    function refresh() {
      var count = selectedCount(optionName, max);
      rows.forEach(function (r, i) {
        var on = i < count;
        r.row.hidden = !on;
        r.input.disabled = !on;
      });
      associate();
    }

    // The variant picker re-renders its options after a change; the count is
    // read again once it has finished (on:variant:change), and immediately on
    // the native change so the rows do not lag behind the click.
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('[data-option="' + optionName + '"]')) refresh();
    });
    document.addEventListener('on:variant:change', refresh);

    var form = mainForm();
    if (form) form.addEventListener('submit', associate, true);

    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-anthology-heartnames]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
